import React from 'react';

interface Props {
  onClick: () => void;
  text: string;
  disabled?: boolean;
  secondaryText?: string;
}

export const StickyButton: React.FC<Props> = ({ onClick, text, disabled, secondaryText }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 pb-6 z-50 glass-panel">
      <button
        onClick={onClick}
        disabled={disabled}
        className={`w-full py-4 rounded-2xl font-bold text-lg flex justify-between px-6 items-center transition-all duration-200
          ${disabled 
            ? 'bg-gray-200 text-gray-400 cursor-not-allowed shadow-none' 
            : 'bg-gradient-to-r from-primary to-blue-600 text-white shadow-lg shadow-blue-500/30 active:scale-[0.98] active:translate-y-0.5'
          }`}
      >
        <span>{text}</span>
        {secondaryText && <span className="opacity-90 font-medium text-sm bg-white/20 px-2 py-1 rounded-lg">{secondaryText}</span>}
      </button>
    </div>
  );
};